import axios, { rootAxios } from "../../axios";
import { useMutation, useQuery, useQueryClient } from "react-query"
import { route } from './routes';
import axiosCore from "axios";

export function useAllOrders(payload) {
  return useQuery([route.ORDER_LIST, JSON.stringify(payload)], async () => {
    const { data } = await axios.post(route.ORDER_LIST, payload);
    return data;
  }, {
    refetchInterval: 3000
  })
}


export function useRunningOrderList(payload) {
  return useQuery([route.RUNNING_ORDER_LIST, JSON.stringify(payload)], async () => {
    const { data } = await axios.post(route.RUNNING_ORDER_LIST, payload);
    return data;
  }, {
    refetchInterval: 3000
  })
}
export function INCompleteOrderList(payload) {
  const { page, pageSize, status, _d } = payload;
  return useQuery([route.IN_COMPLETE_ORDER_LIST, page, pageSize, status, _d], async () => {
    const { data } = await axios.post(route.IN_COMPLETE_ORDER_LIST, payload);
    return data;
  }, {
    refetchInterval: 3000
  })
}

export function OrderListHistory(payload) {
  const { page, pageSize, status, _d } = payload;
  return useQuery([route.ORDER_LIST_HISTORY, page, pageSize, status, _d], async () => {
    const { data } = await axios.post(route.ORDER_LIST_HISTORY, payload);
    return data;
  }, {
    refetchInterval: 3000
  });
}


// get Order Status By Order Id
export function useGetOrderStatusByOrderId(id) {
  return useQuery([route.ORDER_STATUS_BY_ORDER_ID, id], async () => {
    const { data } = await axios.get(`${route.ORDER_STATUS_BY_ORDER_ID}/${id}`);
    return data;
  })
}

export function useChangeOrderStatus() {
  return useMutation(async (payload) => {
    const { data } = await axios.get(route.ORDER_STATUS_CHANGE, payload);
    return data;
  })
}

export async function getCordAddress({ lat, lng }) {
  const { data } = await axiosCore.get(`${route.ADDRESS_BY_LAT_LONG_CORDS}?lat=${lat}&lng=${lng}`);
  return data;
}



// get last seven days data 
export function useLastSevenDaysOrderData() {
  return useQuery([route.ORDER_LIST_STATUS_DATA_FOR_LAST_SEVEN_DAY], async () => {
    const { data } = await axios.get(`${route.ORDER_LIST_STATUS_DATA_FOR_LAST_SEVEN_DAY}`);
    return data;
  })
}


// get All Riding Request 
export function useOrderRiderHistory(orderId) {
  return useQuery([route.GET_ALL_ORDER_RIDER_HISTORY], async () => {
    const { data } = await axios.get(`${route.GET_ALL_ORDER_RIDER_HISTORY}/${orderId}`);
    return data;
  }, {
    enabled: orderId ? true : false
  })
}

// Refund Order
export function useRefundOrder() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.REFUND_ORDER_PAYMENT, payload);
    return data;
  })
}


// Refund Order
export function useOrderDetailsV4(id) {
  return useQuery([route.ORDER_DETAILS_V4, id], async () => {
    const { data } = await axios.get(`${route.ORDER_DETAILS_V4}/${id}`);
    return data;
  }, {
    enabled: id !==null ? true : false
  })
}


// Reset Order status
export function useResetOrderStatus() {
  return useMutation(async ({ order_id }) => {
    const { data } = await axios.get(`${route.RESET_ORDER_STATUS}/${order_id}`);
    return data;
  })
}


export function useRemoveOrderItem() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.REMOVE_PRODUCT_FROM_CART}`, payload);
    return data;
  })
}


export function useProductQtyAdjustOrderItem() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.ADJUST_ORDER_PRODUCT_QTY}`, payload);
    return data;
  })
}


export function useChangePaymentMethod() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.CHANGE_ORDER_PAYMENT_METHOD}`, payload);
    return data;
  })
}

export function useSendOrderNotification() {
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.ORDER_NOTIFICATION_SEND}`, payload);
    return data;
  })
}

export function useAddOrderNote() {
  var id = null;
  const qeuryClient = useQueryClient();
  return useMutation(async (payload) => {
    const { data } = await axios.post(`${route.ADD_ORDER_NOTE}`, payload);
    id = payload.order_id;
    return data;
  }, {
    onSettled:() => {
      qeuryClient.invalidateQueries([route.LIST_ORDER_NOTE, id])
    }
  })
}


export function useOrderNote(id) {
  return useQuery([route.LIST_ORDER_NOTE, id], async () => {
    const { data } = await axios.get(`${route.LIST_ORDER_NOTE}/${id}`);
    return data;
  }, {
    enabled: id !==null ? true : false
  })
}


export function useUpdateOrder() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, ...payload }) => {
    const { data } = await axios.patch(`${route.UPDATE_ORDER}/${id}`, payload);
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}

export function useUpdateOrderProducts() {
  const queryClient = useQueryClient();
  return useMutation(async ({ id, products }) => {
    const { data } = await axios.patch(`${route.UPDATE_ORDER_PRODUCTS}/${id}/products`, { products });
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}

export function useUserTotalSpendingAmount(id) {
  return useQuery([route.GET_TOTAL_USER_SPENDING_AMOUNT, id], async () => {
    const { data } = await axios.get(`${route.GET_TOTAL_USER_SPENDING_AMOUNT}/${id}`);
    return data;
  }, {
    enabled: id !==null ? true : false
  })
}

export function useUserOrderCount(id) {
  return useQuery([route.GET_TOTAL_AND_DELIVERD_ORDER_COUNT, id], async () => {
    const { data } = await axios.get(`${route.GET_TOTAL_AND_DELIVERD_ORDER_COUNT}/${id}`);
    return data;
  }, {
    enabled: id !==null ? true : false
  })
}

export function useCourierProviders() {
  return useQuery([route.COURIER_PROVIDERS], async () => {
    const { data } = await axios.get(route.COURIER_PROVIDERS);
    return data;
  })
}

export function useSendPackageToCourier() {
  const queryClient = useQueryClient();
  return useMutation(async ({ package_id, courier }) => {
    const { data } = await axios.post(route.COURIER_SEND_PACKAGE, { package_id, courier });
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}

export function useRefreshCourierStatus() {
  const queryClient = useQueryClient();
  return useMutation(async ({ package_id, courier }) => {
    const { data } = await axios.get(`${route.COURIER_REFRESH_STATUS}/${package_id}/${courier}`);
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}

export function useSendOrderToCourier() {
  const queryClient = useQueryClient();
  return useMutation(async ({ order_id, courier }) => {
    const { data } = await axios.post(route.COURIER_SEND_ORDER, { order_id, courier });
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}

export function useRefreshOrderCourierStatus() {
  const queryClient = useQueryClient();
  return useMutation(async ({ order_id, courier }) => {
    const { data } = await axios.get(`${route.COURIER_REFRESH_ORDER_STATUS}/${order_id}/${courier}`);
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([route.ORDER_DETAILS_V4]);
    }
  })
}
